document.addEventListener('DOMContentLoaded', () => {

  /*
  |--------------------------------------------------------------------------
  | Text Preview
  |--------------------------------------------------------------------------
  */

  document.querySelectorAll('[id^="personalization-text-"]').forEach(input => {

    const productId = input.id.replace(
      'personalization-text-',
      ''
    );

    const previewText = document.getElementById(
      `PreviewText-${productId}`
    );

    const counter = input
      .closest('.personalization-field')
      ?.querySelector('.personalization-counter');

    const MAX_LENGTH = 12;

    input.addEventListener('input', function () {

      let value = this.value;

      if (value.length > MAX_LENGTH) {
        value = value.substring(0, MAX_LENGTH);
        this.value = value;
      }

      if (previewText) {
        previewText.textContent = value;
      }

      if (counter) {
        counter.textContent =
          `${value.length}/${MAX_LENGTH}`;
      }

    });

  });

  /*
  |--------------------------------------------------------------------------
  | Font Selection
  |--------------------------------------------------------------------------
  */

  document.querySelectorAll(
    '.personalization-font-list input[type="radio"]'
  ).forEach(radio => {

    radio.addEventListener('change', function () {

      const wrapper =
        this.closest('.personalization-font-list');

      const productId =
        wrapper.id.replace(
          'personalization-font-',
          ''
        );

      const previewText =
        document.getElementById(
          `PreviewText-${productId}`
        );

      if (!previewText) return;

      previewText.classList.remove(
        'font-arial',
        'font-playwrite',
        'font-alexbrush',
        'font-iosevka',
        'font-montserrat'
      );

      previewText.classList.add(
        this.value
      );

      wrapper
        .querySelectorAll(
          '.personalization-font-item'
        )
        .forEach(item => {
          item.classList.remove('active');
        });

      this
        .closest('.personalization-font-item')
        .classList.add('active');

    });

  });

  /*
  |--------------------------------------------------------------------------
  | Personalization Submit
  |--------------------------------------------------------------------------
  */

  document
    .querySelectorAll(
      '[id^="PersonalizationSubmit-"]'
    )
    .forEach(button => {

      button.addEventListener(
        'click',
        async function () {

          const productId =
            this.id.replace(
              'PersonalizationSubmit-',
              ''
            );

          const textInput =
            document.getElementById(
              `personalization-text-${productId}`
            );

          const selectedFont =
            document.querySelector(
              `input[name="personalization_font_${productId}"]:checked`
            );

          if (!textInput.value.trim()) {
            alert(
              'Please enter your text.'
            );
            return;
          }

          if (!selectedFont) {
            alert(
              'Please select a font.'
            );
            return;
          }

          const customTextProperty =
            document.getElementById(
              `PropertyCustomText-${productId}`
            );

          const fontProperty =
            document.getElementById(
              `PropertyFont-${productId}`
            );

          const personalizedProperty =
            document.getElementById(
              `PropertyPersonalized-${productId}`
            );

          if (
            !customTextProperty ||
            !fontProperty ||
            !personalizedProperty
          ) {
            alert(
              'Property fields missing.'
            );
            return;
          }

          // customTextProperty.value =
          //   textInput.value.trim();

          // fontProperty.value =
          //   selectedFont
          //     .nextElementSibling
          //     .innerText
          //     .trim();

          // personalizedProperty.value =
          //   'true';

                    customTextProperty.value = textInput.value.trim();
          customTextProperty.disabled = false;

          fontProperty.value = selectedFont
            .nextElementSibling
            .innerText
            .trim();
          fontProperty.disabled = false;

          personalizedProperty.value = 'true';
          personalizedProperty.disabled = false;

          

          const popup =
            document.getElementById(
              `PersonalizationPopup-${productId}`
            );

          if (popup) {
            popup.style.display =
              'none';

            document.body.classList.remove(
              'overflow-hidden'
            );
          }

          const variantId =
            document.getElementById(
              `PersonalizationVariantId-${productId}`
            )?.value;

          if (!variantId) {
            alert(
              'Variant not found.'
            );
            return;
          }

          const lineRef =
            Date.now().toString();

          /*
          |--------------------------------------------------------------------------
          | Collect which sections should be bundled/re-rendered with this request.
          | This mirrors the theme's own product-form.js behavior: the <cart-drawer>
          | custom element (and other listeners) register themselves here via the
          | "cart:prepare-bundled-sections" event, so we don't have to hardcode
          | section names ourselves. This is also what fixes the cart-icon-bubble
          | issue -- cart-count / cart-dot don't rely on a fetched section at all,
          | they just read cart.item_count straight from the cart:change event.
          |--------------------------------------------------------------------------
          */
          let sectionsToBundle = [];

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:prepare-bundled-sections', {
              bubbles: true,
              detail: { sections: sectionsToBundle }
            })
          );

          const payload = {
            items: [
              {
                id: Number(
                  variantId
                ),
                quantity: 1,
                properties: {
                  'Personalized Text':
                    textInput.value.trim(),

                  'Font':
                    selectedFont
                      .nextElementSibling
                      .innerText
                      .trim(),

                  '_personalized':
                    'true',

                  '_personalization_fee':
                    '250',

                  '_line_ref':
                    lineRef
                }
              },

              {
                id:
                  54972826288420,

                quantity: 1,

                properties: {
                  '_service_product':
                    'true',

                  '_line_ref':
                    lineRef,

                  '_parent_variant':
                    variantId
                }
              }
            ],

            // Ask Shopify to render these sections fresh in the same response
            sections: sectionsToBundle.join(',')
          };

          document.documentElement.dispatchEvent(
            new CustomEvent('theme:loading:start', { bubbles: true })
          );

          try {

            const response =
              await fetch(
                '/cart/add.js',
                {
                  method: 'POST',
                  headers: {
                    'Content-Type':
                      'application/json'
                  },
                  body:
                    JSON.stringify(
                      payload
                    )
                }
              );

            const data =
              await response.json();

            document.documentElement.dispatchEvent(
              new CustomEvent('theme:loading:end', { bubbles: true })
            );

            if (!response.ok) {

              alert(
                data.description ||
                data.message ||
                'Unable to add product.'
              );

              // Let cart-related components resync in case anything changed
              document.dispatchEvent(new CustomEvent('cart:refresh'));

              return;
            }

            /*
            |--------------------------------------------------------------------------
            | Refresh Cart via the theme's native event system
            |--------------------------------------------------------------------------
            | Instead of manually fetching "/?sections=..." and swapping DOM nodes
            | ourselves, we follow the exact same pattern the theme's own
            | product-form.js uses: fetch the fresh cart.js, attach the section HTML
            | we got back from add.js, then dispatch "cart:change" on
            | document.documentElement. The <cart-drawer> custom element (and
            | cart-count, cart-dot, free-shipping-bar, etc.) all listen for this
            | event themselves and update + open the drawer automatically.
            |--------------------------------------------------------------------------
            */

            const cartContent =
              await (await fetch('/cart.js')).json();

            cartContent['sections'] = data['sections'];

            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  cart: cartContent
                }
              })
            );

          } catch (error) {

            document.documentElement.dispatchEvent(
              new CustomEvent('theme:loading:end', { bubbles: true })
            );

            console.error(
              error
            );

            alert(
              'Unable to add product to cart.'
            );
          }

        }
      );

    });

});


/* =========================================================
   NEW — ONLY handles the black-pen fix.
   --------------------------------------------------------------------------
   Samples the pen image right where the text sits. If that spot is dark,
   it adds the "engrave-black-fix" class (defined in personalization.css)
   to the text element. If the spot is light/mid-tone, it does nothing —
   the text keeps using the default style that was already working fine
   for gold/silver, completely untouched.
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.personalization-popup').forEach(function (popup) {

    const previewImg = popup.querySelector('.personalization-preview img');
    const previewText = popup.querySelector('.personalization-preview-text');

    if (!previewImg || !previewText) return;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    let imgReady = false;

    function prepCanvas() {
      if (!previewImg.complete || !previewImg.naturalWidth) return;
      canvas.width = previewImg.naturalWidth;
      canvas.height = previewImg.naturalHeight;
      try {
        ctx.drawImage(previewImg, 0, 0, canvas.width, canvas.height);
        imgReady = true;
      } catch (e) {
        // CORS blocked - just leave the default style in place, no fix applied
        imgReady = false;
      }
    }

    function isDarkSurface() {
      if (!imgReady) return false;

      const xPercent = 75; // matches CSS left: 75%
      const yPercent = 55; // matches CSS top: 55%
      const sampleSize = 60;

      const cx = Math.floor((xPercent / 100) * canvas.width);
      const cy = Math.floor((yPercent / 100) * canvas.height);
      const half = sampleSize / 2;

      const sx = Math.max(0, Math.min(canvas.width - 1, cx - half));
      const sy = Math.max(0, Math.min(canvas.height - 1, cy - half));
      const sw = Math.min(canvas.width - sx, sampleSize);
      const sh = Math.min(canvas.height - sy, sampleSize);

      if (sw <= 0 || sh <= 0) return false;

      let data;
      try {
        data = ctx.getImageData(sx, sy, sw, sh).data;
      } catch (e) {
        return false;
      }

      let r = 0, g = 0, b = 0, count = 0;
      for (let i = 0; i < data.length; i += 4) {
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
        count++;
      }
      if (count === 0) return false;

      const avgR = r / count;
      const avgG = g / count;
      const avgB = b / count;
      const luminance = 0.299 * avgR + 0.587 * avgG + 0.114 * avgB;

      return luminance < 90; // only very dark surfaces (black pens) count
    }

    function applyBlackFixIfNeeded() {
      if (isDarkSurface()) {
        previewText.classList.add('engrave-black-fix');
      } else {
        previewText.classList.remove('engrave-black-fix');
      }
    }

    if (previewImg.complete) {
      prepCanvas();
      applyBlackFixIfNeeded();
    } else {
      previewImg.addEventListener('load', function () {
        prepCanvas();
        applyBlackFixIfNeeded();
      });
    }

    const productId = popup.id.replace('PersonalizationPopup-', '');
    const openBtn = document.getElementById('PersonalizeButton-' + productId);
    if (openBtn) {
      openBtn.addEventListener('click', function () {
        requestAnimationFrame(function () {
          prepCanvas();
          applyBlackFixIfNeeded();
        });
      });
    }
  });

});